import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import { formatNumber } from '../../../reducer/actions/formatNumber';
import Box from '@mui/material/Box';
import { formatPrice } from '../../../reducer/actions/formatPrice';
import { gridFilteredSortedRowEntriesSelector } from '@mui/x-data-grid-pro';

export const NumberSummaryCell = ({
  props,
  apiRef,
  schema,
}: {
  props: any;
  apiRef: any;
  schema: any;
}): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);
  const [total, setTotal] = useState(0);
  const isId = props?.field === 'id';

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell'] && !isId) {
      setTooltip(true);
    }
  });

  const filteredSortedRowsAndIds = gridFilteredSortedRowEntriesSelector(apiRef);
  const visibleRows = filteredSortedRowsAndIds.map((row: any) => row?.model);

  useEffect(() => {
    let sum = 0;

    const addAmounts = (row: any, field: string) => {

      if (row?.type?.id === 4){
        return;
      }

      sum += row[field] || 0;
    };

    visibleRows.forEach((row: any) => {
      if (!row) return;

      const field = props.field;

      addAmounts(row, field);
    });

    setTotal(sum);

  }, [visibleRows]);

  return (
    <Box
      ref={divRef}
      className={`whitespace-nowrap ${
        tooltip ? 'has-tooltip' : 'doesnthave-tooltip'
      }`}
      sx={{
        lineHeight: '14px',
      }}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={formatNumber(total)}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <>{total ? <p>{formatNumber(total)}</p> : <></>}</>
          </Tooltip>
        </>
      ) : (
        <>
          <>{!isId ? <p>{formatNumber(total)}</p> : <></>}</>
        </>
      )}
    </Box>
  );
};
